module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.10.0.0.box.638.207.480.40.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.10.0.0.box.638.207.480.40.q.100"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.216.390.1323.1971.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.0.box.218.390.1320.280.q.60"
    }
  }, [_vm._v("This is first and foremost a story about the various roles filled by Confederate women during The War for Southern Independence. In spite of the constraints of their traditional roles in southern society, they not only served as nurse and caretaker but also as spy, prisoner for their cause and even soldier. This then is their story.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.217.684.1322.689.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  }), _vm._v("To empathize with the women who experienced the War Between the States from the Confederate perspective, we must understand their place in 19th century society. In this regard, their role is almost universal. Women had the unique perspective of being more or less spectators of their world, while men ruled and made the decisions. When war came, Southern women found themselves observers in a patriarchal society — missing its patriarchs. The men had all been removed to the path of war. Perhaps because of their previous \"observer role\" those women were able to recognize quickly what was lacking in society. When war came, it brought the opportunity to act on these observations, step in with efficiency and fill very competently many roles which were previously nonexistent.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.2.box.216.1386.1321.624.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  }), _vm._v("The ten women presented here have been chosen because they so well represent the role of many. With the exception of Loreta Valezquez, most have been remaindered to history's shelves in obscurity. The difficulty associated with finding documentation on women of the period makes it rare to write a complete story of an individual's experience. One historian stated that a woman was mentioned only three times in her life—when she was born, when she married, and when she died. There is some truth in this. Unless she kept a diary, or letters were preserved, there is little record of the average woman, unless she is mentioned indirectly because she was married to a prominent husband.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.3.box.216.2024.1321.337.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("What has been attempted here is to gather stories of women not particularly the wealthiest or most socially prominent, of their time. The roles represented vary, but have common threads—the patriotic love of country, faith in God, and dedication to family. The independent women of today feel they are the first to challenge and achieve an equality in a male-oriented society. But Confederate"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.11.1.0.box.216.303.1320.397.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("\nwomen proved themselves capable. They drew from a remarkable inner strength—with no assistance from therapists or support groups. One impression these stories successfully refute is the myth that Southern women were largely social ornaments, male-dominated and poorly educated intellectually. On the contrary, they ran the country's day-to-day existence, and were accepted as capable and equal by such authority figures as generals and politicians.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.11.1.0.box.216.303.1322.2082.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.1.box.218.714.1318.220.q.60"
    }
  }, [_vm._v("One cannot read of Ella Newsom's relationships with the Confederate high Command and think anything but that she was truly treated as an equal, whose opinion was valued in regard to the good of the army.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.2.box.217.948.1319.279.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.2.0"
    }
  }), _vm._v("If courage may be considered a term largely applied to men on a battlefield, consider the quiet courage of Mary Terry who endured the discomfort of a federal prison for her beliefs and refusal to abandon principles. The courage required of these women is no less the degree required of their male counterparts on the field.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.3.box.216.1240.1322.448.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.3.0"
    }
  }), _vm._v("There's a different kind of emotional courage found in the love of Charlotte Branch as a mother, and Susan Tarleton as a fiancee. Charlotte watched her most prized possessions—her sons— sacrificed and endangered for four years. Susan Tarleton was a young bride-to-be with everything before her, until the tragic news arrived that her future had been destroyed needlessly before the ditches at Franklin. We can only imagine the heartbreak thousands of mothers, lovers, and wives faced daily.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.4.box.217.1702.1321.160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.4.0"
    }
  }), _vm._v("Adventurous roles also presented themselves, and were filled, by women such as Loreta Velazquez who \"went for a soldier\", and the homefront girls of the Nancy Harts.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.5.box.218.1876.1319.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.5.0"
    }
  }), _vm._v("The willingness to pitch in and sacrifice is evident in the successful \"war work\" of the ladies' aid societies. It is reminiscent of the more recent World War II USO, and canteens for the troops of the 1940s.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.6.box.216.2107.1322.278.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.6.0"
    }
  }), _vm._v("Finally, some roles reached beyond the war years to record the turbulent times, and keep memory of those lost alive. These we represent with Margaret Junkin Preston as the poet, and Mary Amarinthis Snowden and her dedication to Confederate Memorial Day, and the remembrance of who and what was sacrificed.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.1.0.box.217.302.1328.399.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.0.box.217.302.1328.399.q.60"
    }
  }, [_vm._v("The female contributions may seem neglected to us in our reading today, but they were not overlooked as long as the veterans of the Confederate Army were alive. Monuments were erected to the Women of the South in several states. Poems were written, and incidents recounted which left lasting impressions on the minds of young suffering soldiers. Perhaps one verse from Albert Sidney Morton's poem \"Women of the "), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.2.0"
    }
  }), _vm._v("South\" sums it up best:")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "2em",
      "margin-right": "2em"
    },
    attrs: {
      "id": "block.12.2.0.box.468.774.817.510.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.12.2.0.box.468.774.817.451.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  }), _vm._v("Who bade us go with smiling tears? "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.1.0"
    }
  }), _vm._v("Who scorned the renegade? "), _c('br'), _vm._v("Who, silencing their trembling fears, "), _c('br'), _vm._v("Watched, cheered, then wept and prayed? "), _c('br'), _vm._v("Who nursed our wounds with tender care, "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.2.0"
    }
  }), _vm._v("And then when all was lost, "), _c('br'), _vm._v("Who lifted us from our despair? "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.3.0"
    }
  }), _vm._v("And counted not the cost? "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.12.2.1.box.527.1249.700.35.q.80"
    }
  }, [_vm._v("THE WOMEN OF THE SOUTH. "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.3.0.box.217.1368.1322.340.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.3.0.box.217.1368.1322.340.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.0.0"
    }
  }), _vm._v("What can we take away from these individual stories to give us new perspective and u"), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v("nderstanding? We cannot fail to be inspired by their examples as role models, and we can admire their compassion, suffering and eventual survival during the crucible in both their lives and our nation's his"), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  }), _vm._v("tory. These traits are still pertinent even into this millennium, reminding us that they are timeless virtues.")]), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.13.0.0.box.216.292.1336.1791.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0.2"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 57
// module chunks = 0